import Drawer from "@components/shared/Drawer";
import AppContext from "@helpers/context";
import ChannelAPI from "@network/api/channel";
import RoleAPI from "@network/api/role";
import {
  AwesomeTableComponent,
  InputTextSearch,
  Select,
  TimeUtils,
} from "d-react-components";
import { useFormik } from "formik";
import { debounce } from "lodash";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

function ChannelDetailUserLoadDrawer({ open, onClose, onSave }: any) {
  const channelContext = useContext(AppContext);
  const { t } = useTranslation();
  const { channelId } = useParams();

  const [channelList, setChannelList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const tableRef = useRef<any>();
  const textSearch = useRef<string>("");

  const loadUserForm = useFormik({
    initialValues: {
      users: [],
      channel: null,
      role: null,
    },
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      onSave(values?.users);
    },
  });

  const columns = [
    {
      title: t("name"),
      dataIndex: "fullname",
    },
    {
      title: t("nickName"),
      dataIndex: "name",
    },
    {
      title: t("companyId"),
      dataIndex: "companyId",
      width: 150,
    },
    {
      title: t("lastLogin"),
      dataIndex: "last_login",
      render: TimeUtils.toDateTime,
    },
  ];

  useEffect(() => {
    loadChannelList();
    loadRoleList();
  }, []);

  const source = (paging: any) => {
    const { channel, role } = loadUserForm?.values;
    if (!channel) return Promise.resolve([]);
    const body = {
      id: channel,
      role,
      search: textSearch.current,
      channel_id: channelId,
    };
    return ChannelAPI.userLoad(body, paging);
  };

  const transformer = (res: any) => res?.data?.data?.users ?? [];

  const onChangeText = debounce((text) => {
    textSearch.current = text;
    tableRef.current.refresh();
  }, 1000);

  const loadChannelList = (textSearch?: any) => {
    ChannelAPI.list(
      { search: textSearch },
      { pageIndex: 1, pageSize: 20 }
    ).then((res) => {
      setChannelList(res?.data?.data?.channels ?? []);
    });
  };

  const loadRoleList = () => {
    RoleAPI.list().then((res) => {
      const roleList = res?.data?.data?.roles ?? [];
      setRoleList(roleList);
    });
  };

  const formValue = loadUserForm?.values;

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={t("loadUser")}
      onSave={() => loadUserForm.handleSubmit()}
      // disabledSaveButton={formValue?.users?.length === 0}
      size="auto"
      width="50vw"
    >
      <div>
        <Select
          label={t("channel")}
          onSearch={loadChannelList}
          showSearch
          dataSource={channelList}
          getLabel={(item) => item.name}
          value={formValue?.channel}
          onChange={(value) => {
            loadUserForm.setFieldValue("channel", value);
            tableRef.current.refresh();
          }}
        />
        <Select
          label={t("role")}
          className="mt-3"
          dataSource={roleList}
          getLabel={(item) => item.name}
          value={formValue?.role}
          onChange={(value) => {
            loadUserForm.setFieldValue("role", value);
            tableRef.current.refresh();
          }}
        />
        <label className="mt-3">{t("allUsers")}</label>
        <InputTextSearch
          onChange={(event: any) => onChangeText(event.target.value)}
        />
        <AwesomeTableComponent
          ref={(ref) => {
            tableRef.current = ref;
          }}
          columns={columns}
          source={source}
          transformer={transformer}
          className="mt-3"
          rowSelection={{
            onChange: (selectedRowKeys, selectedRows) => {
              loadUserForm.setFieldValue("users", selectedRows);
            },
          }}
          baseColumnProps={{ with: 100 }}
        />
      </div>
    </Drawer>
  );
}

export default ChannelDetailUserLoadDrawer;
